import { defineService, } from '../../index.js';
export const SignalsServiceDefinition = defineService('core:signals');
